import { CustomerEventType, MessageType } from '@backend/domain'

export class MessageTypeMapper {
	static messageTypeToCustomerEventType(messageType: MessageType): CustomerEventType | undefined {
		switch (messageType) {
			case MessageType.order: {
				return CustomerEventType.order_placed
			}
			case MessageType.request_order: {
				return CustomerEventType.order_requested
			}
			case MessageType.request_payment: {
				return CustomerEventType.payment_request
			}
			case MessageType.request_waiter: {
				return CustomerEventType.waiter_requested
			}
			case MessageType.card_payment_complete: {
				return CustomerEventType.online_payment
			}
			default: {
				return undefined
			}
		}
	}
}
